import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { fDateN } from '../../utils/formatTime';
import dagpacketdLogo from '../../assets/dagpacketd.png';

const PDFPaquetesRecepcionados = ({ data, logo = 'dagpacket' }) => {
  const { created_at, paquetes, totalAPagar, remitente, medioDePago } = data;
  return (
    <Document>
      <Page size="C7">
        <View style={{ padding: '10px', fontSize: '9px', display: 'flex', flexDirection: 'column' }}>
          <Text style={{ fontSize: '12px', fontWeight: 'black', textAlign: 'center' }}>
            Recepción paquetería multimarca
          </Text>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center'
            }}
          >
            <View style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row' }}>
              <Image src={dagpacketdLogo} style={{ height: 45 }} />
            </View>
          </View>
          <View style={{ marginVertical: '7px', textAlign: 'center' }}>
            <Text style={{ fontSize: '9px' }}>{created_at ? fDateN(created_at) : '-'}</Text>
          </View>
          <View
            style={{
              marginTop: '5px',
              textAlign: 'center'
            }}
          >
            <Text>Remitente : {`${remitente?.nombreRemitente}`}</Text>
          </View>
          <View
            style={{
              marginTop: '5px',
              textAlign: 'center',
              marginBottom: '5px'
            }}
          >
            <Text>Teléfono : {`${remitente?.telefonoRemitente}`}</Text>
          </View>
          <View style={{ marginTop: '5px', textAlign: 'center', marginBottom: '5px' }}>
            <Text style={{ fontSize: '12px', fontWeight: 'bold' }}>N° Paquetes: {paquetes?.length}</Text>
          </View>
          {data.paquetes.map((paq, i) => (
            <View
              style={{
                marginTop: '5px',
                textAlign: 'center',
                marginBottom: '5px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
              }}
              key={i}
            >
              <Text>N° Tracking: {`${paq.tracking}`}</Text>
              <Text>Paquetería: {`${paq.paqueteria}`}</Text>
            </View>
          ))}
          <View
            style={{
              marginTop: '5px',
              borderBottomWidth: 1,
              borderBottomColor: '#112131',
              borderBottomStyle: 'solid',
              textAlign: 'center',
              paddingBottom: 15,
              marginBottom: 10
            }}
          >
            <Text>Medio de pago : {medioDePago}</Text>
          </View>
          <View
            style={{
              marginTop: '5px',
              fontSize: '12px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between'
            }}
          >
            <Text style={{ fontWeight: 'black' }}>Total</Text>
            <Text>$ {totalAPagar}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default PDFPaquetesRecepcionados;
